module.exports = __webpack_public_path__ + "img/00009.652d9808.webp";